import axios from 'axios';

export const download = async (fileUrl: string, fileName: string) => {
  try {
    const res = await axios({
      responseType: 'blob',
      url: fileUrl,
    });

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.log('error', error);
  }
};
